import React from 'react';
import { Helmet } from 'react-helmet';
import MesDevis from '../MesDevis';

export default function ClientQuotes() {
  return (
    <div className="min-h-screen bg-gray-900 p-6">

      <div className="max-w-7xl mx-auto space-y-6">
        <MesDevis />
      </div>
    </div>
  );
}